import getOidcUrl from 'root/src/client/util/getOidcUrl'
import wait from 'root/src/shared/util/wait'

export default provider => state => async () => {
	window.location.replace(getOidcUrl(provider, undefined, state))
	await wait(20000)
}
